"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireDefault(require("react"));
var _CompletedContext = require("../CompletedContext");
var _abcjs = _interopRequireDefault(require("@bittnerdevelopmentgroup/abcjs"));
var _fractional = require("fractional");
var _MusicUtil = require("../TaskScaleBuilder/MusicUtil");
var _reactUuid = _interopRequireDefault(require("react-uuid"));
require("./TaskMusicPlayer.css");
var TaskMusicPlayer = exports.default = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TaskMusicPlayer, _React$Component);
  var _super = (0, _createSuper2.default)(TaskMusicPlayer);
  function TaskMusicPlayer(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TaskMusicPlayer);
    _this = _super.call(this, props);
    _this.state = props.state || {};
    if (!_this.state.initialized) {
      _this.state.initialized = true;
      // Initial state is set here, since the constructor can be called more than once.
      _this.state.completed = false;
      _this.state.showAnswer = false;
      _this.state.notation = _this.props.notation;
      _this.state.id = (0, _reactUuid.default)();
    }
    _this.changePlayState = _this.changePlayState.bind((0, _assertThisInitialized2.default)(_this));
    _this.onFinished = _this.onFinished.bind((0, _assertThisInitialized2.default)(_this));
    _this.synthControlRef = /*#__PURE__*/_react.default.createRef();
    _this.synthEngraverRef = /*#__PURE__*/_react.default.createRef();
    return _this;
  }
  (0, _createClass2.default)(TaskMusicPlayer, [{
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
      this.controller = new _abcjs.default.synth.SynthController();
      window.AudioContext = window.AudioContext || window.webkitAudioContext || navigator.mozAudioContext || navigator.msAudioContext;
      this.audioContext = new window.AudioContext();
      this.renderPlayer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }
      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
      if (this.props["notation"] !== prevprops["notation"] || this.props["musicDuration"] !== prevprops["musicDuration"]) {
        this.renderPlayer();
      }
    }
  }, {
    key: "onFinished",
    value: function onFinished() {
      this.setState({
        completed: true
      });
    }
  }, {
    key: "renderPlayer",
    value: function renderPlayer() {
      var render_config = {
        add_classes: true
      };
      if (_abcjs.default.synth.supportsAudio() && this.synthControlRef.current && this.synthEngraverRef.current) {
        this.controller.load(this.synthControlRef.current, {
          onFinished: this.onFinished
        }, {
          displayLoop: true,
          displayRestart: true,
          displayPlay: true,
          displayProgress: true,
          displayWarp: true
        });
        var visualObj = _abcjs.default.renderAbc(this.synthEngraverRef.current, this.state.notation, render_config);
        var synthControl = this.controller;
        var createSynth = new _abcjs.default.synth.CreateSynth();
        createSynth.init({
          visualObj: visualObj[0],
          audioContext: this.audioContext,
          millisecondsPerMeasure: this.props.millisecondsPerMeasure || 2000
        }).then(function () {
          synthControl.setTune(visualObj[0], false, {
            chordsOff: true
          }).then(function () {}).catch(function (error) {
            console.warn("Audio problem:", error);
          });
        }).catch(function (error) {
          console.warn("Audio problem:", error);
        });
      } else {
        document.querySelector("#audio").innerHTML = "Audio is not supported in this browser.";
      }
    }
  }, {
    key: "serializeNote",
    value: function serializeNote(note, extra, clef) {
      var ret = "";
      if (note.chord) {
        var _iterator = (0, _createForOfIteratorHelper2.default)(note.chord),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _annotation_position_;
            var chord = _step.value;
            ret += "\"".concat((_annotation_position_ = _MusicUtil.annotation_position_to_character[chord.position]) !== null && _annotation_position_ !== void 0 ? _annotation_position_ : "@").concat(chord.name, "\"");
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if (note.gracenotes) {
        ret += "{";
        var _iterator2 = (0, _createForOfIteratorHelper2.default)(note.gracenotes),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var grace = _step2.value;
            if (clef === "treble") {
              ret += (0, _MusicUtil.get_treble_pitch)(grace.pitch);
            } else if (clef === "bass") {
              ret += (0, _MusicUtil.get_bass_pitch)(grace.pitch);
            } else if (clef === "alto") {
              ret += (0, _MusicUtil.get_alto_pitch)(grace.pitch);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        ret += "}";
      }
      if (note.decoration) {
        var _iterator3 = (0, _createForOfIteratorHelper2.default)(note.decoration),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var dec = _step3.value;
            if (dec === "irishroll") {
              ret += "~";
            } else {
              console.log("unknown decoration: ", dec);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      if (note.rest) {
        ret += "z";
      } else if (note.pitches) {
        if (note.pitches.length > 1) {
          ret += "[";
        }
        var _iterator4 = (0, _createForOfIteratorHelper2.default)(note.pitches),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var pitch = _step4.value;
            if (clef === "bass") {
              ret += (_MusicUtil.accidentals[pitch.accidental] || "") + (0, _MusicUtil.get_bass_pitch)(pitch.verticalPos);
            } else if (clef === "treble") {
              ret += (_MusicUtil.accidentals[pitch.accidental] || "") + (0, _MusicUtil.get_treble_pitch)(pitch.pitch);
            } else if (clef === "alto") {
              ret += (_MusicUtil.accidentals[pitch.accidental] || "") + (0, _MusicUtil.get_alto_pitch)(pitch.verticalPos);
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        if (note.pitches.length > 1) {
          ret += "]";
        }
      }
      var default_length = this.lastParse && this.lastParse[0].multilineVars && this.lastParse[0].multilineVars.default_length || 0.25;
      if (note.duration !== default_length) {
        var ratio = new _fractional.Fraction(note.duration / default_length);
        var frac = ratio.numerator;
        if (ratio.denominator !== 1) frac += "/" + ratio.denominator;
        ret += frac;
      }
      if (extra === undefined) {
        extra = note.endChar - note.startChar - ret.length;
      }
      if (extra > 0) {
        if (note.pitches && (note.pitches[0].startSlur || note.pitches[0].endSlur)) extra--;else ret += " ".repeat(extra);
      }
      return ret;
    }
  }, {
    key: "changePlayState",
    value: function changePlayState(s) {
      this.setState({
        playing: s
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "music-player",
        style: this.props.style
      }, /*#__PURE__*/_react.default.createElement("div", {
        id: "synth-engraver-".concat(this.state.id),
        ref: this.synthEngraverRef,
        className: "sr-only",
        "aria-hidden": "true"
      }), /*#__PURE__*/_react.default.createElement("div", {
        id: "synth-control-".concat(this.state.id),
        ref: this.synthControlRef
      }));
    }
  }]);
  return TaskMusicPlayer;
}(_react.default.Component);
TaskMusicPlayer.contextType = _CompletedContext.CompletedContext;